'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackAdded;

var _actions = require('../../store/actions');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * The `addtrack` listener is called when the video has track metadata. This
 * is information like, duration, qualities, etc.
 *
 * This is where we bootstrap the app with the `qualities` object from
 * `hudl-video-playback`/`theoplayer`
 */
/*
 * @providesModule defaultLoadedMetadataListener
 * 
 */

function trackAdded(state, next, playerId) {
  var player = _store2.default.getPlayerInstance(playerId);

  _store2.default.storeInstance().dispatch((0, _actions.setAspectRatio)(playerId, player.aspectRatio));

  _store2.default.storeInstance().dispatch((0, _actions.setQualities)(playerId, player.qualities));

  _store2.default.storeInstance().dispatch((0, _actions.setLive)(playerId, player.live));

  if (player.live) {
    _store2.default.storeInstance().dispatch((0, _actions.setCurrentTimeMs)(playerId, 0));
  }
}
module.exports = exports['default'];